// extracted by mini-css-extract-plugin
export default {"container":"ReviewCampaignDetail_container__tuxxv","card":"ReviewCampaignDetail_card__MeHRJ"};